import axios from '../../config/axios';
import config from '../../config/api';
import { setSnackbar } from './SnackbarAction';


export const getIsos = (data) => ({
    type: 'GET_ISOS',
    data
})

export const getProcessors = (data) => ({
    type: 'GET_PROCESSORS',
    data
})

export const getTerminalMake = (data) => ({
    type: 'GET_TERMINAL_MAKE',
    data
})


export const getMerchants = (data) => ({
    type: 'GET_MERCHANTS',
    data
})

export const getReportTypes = (data) => ({
    type: 'GET_REPORT_TYPES',
    data
})

export const getPrefix = (data) => ({
    type: 'GET_PREFIX',
    data
})

export const getStates = (data) => ({
    type: 'GET_STATES',
    data
})

export const getProcessorTerminalModels = (data) => ({
    type: 'GET_PROCESSOR_TERMINAL_MODELS',
    data
})

export const getProcessorConnections = (data) => ({
    type: 'GET_PROCESSOR_CONNECTIONS',
    data
})

export const getProcessorTerminals = (data) => ({
    type: 'GET_PROCESSOR_Terminals',
    data
})

export const getAllProcessorTerminals = (data) => ({
    type: 'GET_ALL_PROCESSOR_Terminals',
    data
})

export const getHistoryProcessorTerminals = (data) => ({
    type: 'GET_HISTORY_PROCESSOR_Terminals',
    data
})

export const getIsosForMerchantAssigment = (data) => ({
    type: 'GET_ISOS_FOR_MERHCANT_ASSIGNMENT',
    data
})

export const getMerchantProcessorTerminals = (data) => ({
    type: 'GET_MERCHANT_PROCESSOR_TERMINALS',
    data
})

export const getBankStatementDescriptors = (data) => ({
    type: 'GET_BANK_STATEMENT_DESCRIPTORS',
    data
})


export const fetchIsos = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/isos`).then(response => {
            if (response.status === 200) {
                dispatch(getIsos(response.data));
            } else {
                dispatch(getIsos([]));
            }
        }).catch(error => {
            dispatch(getIsos([]));
        })
    }
}

export const fetchIsosForMerchantAssignment = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/isosForPOS`).then(response => {
            if (response.status === 200) {
                dispatch(getIsosForMerchantAssigment(response.data));
            } else {
                dispatch(getIsosForMerchantAssigment([]));
            }
        }).catch(error => {
            dispatch(getIsosForMerchantAssigment([]));
        })
    }
}

export const fetchProcessors = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/processors`).then(response => {
            if (response.status === 200) {
                dispatch(getProcessors(response.data));
            } else {
                dispatch(getProcessors([]));
            }
        }).catch(error => {
            dispatch(getProcessors([]));
        })
    }
}
export const fetchTerminalMake = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/terminalMakes`,).then(response => {
            if (response.status === 200) {
                dispatch(getTerminalMake(response.data));
            } else {
                dispatch(getTerminalMake([]));
            }
        }).catch(error => {
            dispatch(getTerminalMake([]));
        })
    }
}

export const fetchMerchants = (merchantID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/terminals/${merchantID}`).then(response => {
            if (response.status === 200) {
                dispatch(getMerchants(response.data));
            } else {
                dispatch(getMerchants([]));
            }
        }).catch(error => {
            dispatch(getMerchants([]));
        })
    }
}

export const fetchReportTypes = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/getReportTypes`,).then(response => {
            if (response.status === 200) {
                dispatch(getReportTypes(response.data));
            } else {
                dispatch(getReportTypes([]));
            }
        }).catch(error => {
            dispatch(getReportTypes([]));
        })
    }
}


export const fetchPrefix = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/getProcessorPrefixes`,).then(response => {
            if (response.status === 200) {
                dispatch(getPrefix(response.data));
            } else {
                dispatch(getPrefix([]));
            }
        }).catch(error => {
            dispatch(getPrefix([]));
        })
    }
}

export const fetchProcessorTerminalModels = () => {
    return function (dispatch) {
        console.log('Fetching Processor Models')
        axios.get(`${config.api.FETCH_URL}/ddl/getProcessorTerminalModels`,).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorTerminalModels(response.data));
            } else {
                dispatch(getProcessorTerminalModels([]));
            }
        }).catch(error => {
            dispatch(getProcessorTerminalModels([]));
        })
    }
}

export const fetchProcessorConnections = () => {
    return function (dispatch) {
        console.log('Fetching Processor Conections')
        axios.get(`${config.api.FETCH_URL}/ddl/getProcessorConnections`,).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorConnections(response.data));
            } else {
                dispatch(getProcessorConnections([]));
            }
        }).catch(error => {
            dispatch(getProcessorConnections([]));
        })
    }
}

// export const fetchProcessorTerminals = () => {
//     return function (dispatch) {
//         console.log('Fetching Processor Terminals')
//         axios.get(`${config.api.FETCH_URL}/ddl/getProcessorTerminals`,).then(response => {
//             if (response.status === 200) {
//                 dispatch(getProcessorTerminals(response.data));
//             } else {
//                 dispatch(getProcessorTerminals([]));
//             }
//         }).catch(error => {
//             dispatch(getProcessorTerminals([]));
//         })
//     }
// }

export const fetchProcessorTerminalsForAssignment = (merchantID) => {
    return function (dispatch) {
        console.log('Fetching Processor Terminals')
        axios.get(`${config.api.FETCH_URL}/ddl/getProcessorTerminalsForAssignment/${merchantID}`,).then(response => {
            if (response.status === 200) {
                dispatch(getProcessorTerminals(response.data));
            } else {
                dispatch(getProcessorTerminals([]));
            }
        }).catch(error => {
            dispatch(getProcessorTerminals([]));
        })
    }
}


export const fetchAllProcessorTerminals = () => {
    return function (dispatch) {
        console.log('Fetching All Processor Terminals')
        axios.get(`${config.api.FETCH_URL}/ddl/getAllProcessorTerminals`,).then(response => {
            if (response.status === 200) {
                dispatch(getAllProcessorTerminals(response.data));
            } else {
                dispatch(getAllProcessorTerminals([]));
            }
        }).catch(error => {
            dispatch(getAllProcessorTerminals([]));
        })
    }
}

export const fetchHistoryProcessorTerminals = () => {
    return function (dispatch) {
        console.log('Fetching History Processor Terminals')
        axios.get(`${config.api.FETCH_URL}/ddl/getHistoryProcessorTerminals`,).then(response => {
            if (response.status === 200) {
                dispatch(getHistoryProcessorTerminals(response.data));
            } else {
                dispatch(getHistoryProcessorTerminals([]));
            }
        }).catch(error => {
            dispatch(getHistoryProcessorTerminals([]));
        })
    }
}


export const addPrefix = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/admin/addPrefix`, body).then(response => {
            if (response.status === 201) {
                dispatch(fetchPrefix())
                dispatch(setSnackbar(true, 'success', 'Prefix Added Successfully'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Error Adding Prefix, try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Error Adding Prefix, try again'))
        })
    }
}

export const deletePrefix = (prefixValue) => {
    return function (dispatch) {
        axios.delete(`${config.api.FETCH_URL}/admin/deletePrefix/${prefixValue}`,).then(response => {
            if (response.status === 200) {
                dispatch(fetchPrefix());
                dispatch(setSnackbar(true, 'success', 'Removed Processor Prefix'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Error removing Processor prefix, try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Error removing Processor prefix, try again'))
        })
    }
}

export const fetchMerchantProcessorTerminals = (merchantID) => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/processorTerminals/${merchantID}`).then(response => {
            if (response.status === 200) {
                dispatch(getMerchantProcessorTerminals(response.data));
                console.log('Response : ', response.data)
            } else {
                dispatch(getMerchantProcessorTerminals([]));
            }
        }).catch(error => {
            dispatch(getMerchantProcessorTerminals([]));
        })
    }
}


export const addBankStatementDescriptor = (body) => {
    return function (dispatch) {
        axios.post(`${config.api.FETCH_URL}/admin/addBankStatementDescriptor`, body).then(response => {
            if (response.status === 200) {
                dispatch(fetchBankStatementDescriptors())
                dispatch(setSnackbar(true, 'success', 'Bank Statement Descriptor Added Successfully'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Error Adding Bank Statement Descriptor, try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Error Adding Bank Statement Descriptor, try again'))
        })
    }
}

export const deleteBankStatementDescriptor = (bankStatementDescriptorID) => {
    return function (dispatch) {
        axios.delete(`${config.api.FETCH_URL}/admin/deleteBankStatementDescriptor/${bankStatementDescriptorID}`,).then(response => {
            if (response.status === 200) {
                dispatch(fetchBankStatementDescriptors());
                dispatch(setSnackbar(true, 'success', 'Removed Bank Statement Descriptor'))
            } else {
                dispatch(setSnackbar(true, 'error', 'Bank Statement Descriptor, try again'))
            }
        }).catch(error => {
            dispatch(setSnackbar(true, 'error', 'Bank Statement Descriptor, try again'))
        })
    }
}

export const fetchBankStatementDescriptors = () => {
    return function (dispatch) {
        axios.get(`${config.api.FETCH_URL}/ddl/getBankstatementDescriptors`,).then(response => {
            if (response.status === 200) {
                dispatch(getBankStatementDescriptors(response.data));
            } else {
                dispatch(getBankStatementDescriptors([]));
            }
        }).catch(error => {
            dispatch(getBankStatementDescriptors([]));
        })
    }
}
